// Type
import {contractPhoneNumber} from '@drivesally/sally-fn/lib/types';

export default ({driver: {phone_number = ''} = {}} = {}) =>
  contractPhoneNumber(phone_number).format();
